import { Link } from "react-router-dom";

export default function AuthShell({ title, subtitle, children, footer }) {
  const BACKEND = process.env.REACT_APP_BACKEND_URL;
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const googleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-navy text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "url(https://images.pexels.com/photos/18729404/pexels-photo-18729404.jpeg)", backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-gradient-to-br from-navy to-emerald-deep/40" />
        <Link to="/" className="relative flex items-center gap-2 font-heading font-extrabold text-xl">
          <img src="/certy-icon.png" alt="GetCerty" className="h-10 w-10 rounded-lg bg-white p-0.5 object-contain" /> GetCerty
        </Link>
        <div className="relative max-w-md">
          <h2 className="font-heading text-3xl font-bold leading-tight">Compliance built for your nation.</h2>
          <p className="mt-4 text-white/70">England, Wales and Scotland each have their own rules. GetCerty keeps you on top of every one of them.</p>
        </div>
        <p className="relative text-sm text-white/50">UK GDPR compliant · Encrypted storage</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 bg-background">
        <div className="w-full max-w-sm">
          <Link to="/" className="lg:hidden flex items-center gap-2 font-heading font-extrabold text-lg mb-8">
            <img src="/certy-icon.png" alt="GetCerty" className="h-8 w-8 rounded-lg bg-white border border-border p-0.5 object-contain" /> GetCerty
          </Link>
          <h1 className="font-heading text-2xl font-bold">{title}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
          <div className="mt-6">{children}</div>
          <button data-testid="google-login" onClick={googleLogin} className="mt-4 w-full min-h-[48px] flex items-center justify-center gap-2 rounded-xl border border-border bg-card hover:bg-secondary font-medium transition-colors">
            <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="" className="h-5 w-5" /> Continue with Google
          </button>
          <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>
        </div>
      </div>
    </div>
  );
}
